import { Tool } from '../../types';

export const businessIntelligenceTools: Tool[] = [
  {
    id: 'tableau',
    name: 'Tableau',
    category: 'Business Intelligence',
    description: 'Interactive data visualization and analytics platform',
    pricing: ['medium', 'high'],
    features: ['integrations', 'mobile', 'scalability'],
    bestFor: ['small-business', 'startup'],
    compatibleWith: ['saas', 'e-commerce', 'service-business'],
    goals: ['streamline-operations', 'increase-sales'],
    industries: ['technology', 'finance', 'retail'],
    website: 'https://www.tableau.com',
    imageUrl: 'https://logo.clearbit.com/tableau.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['intermediate', 'advanced'],
    minTeamSize: 'small'
  },
  {
    id: 'power-bi',
    name: 'Power BI',
    category: 'Business Intelligence',
    description: 'Business analytics and data visualization tool',
    pricing: ['low', 'medium'],
    features: ['integrations', 'mobile', 'ease-of-use'],
    bestFor: ['small-business', 'startup'],
    compatibleWith: ['service-business', 'e-commerce'],
    goals: ['streamline-operations', 'increase-sales'],
    industries: ['finance', 'retail', 'technology'],
    website: 'https://powerbi.microsoft.com',
    imageUrl: 'https://logo.clearbit.com/microsoft.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['intermediate', 'advanced'],
    minTeamSize: 'small'
  },
  {
    id: 'looker',
    name: 'Looker',
    category: 'Business Intelligence',
    description: 'Modern business intelligence and analytics platform',
    pricing: ['medium', 'high'],
    features: ['integrations', 'scalability', 'automation'],
    bestFor: ['startup', 'small-business'],
    compatibleWith: ['saas', 'e-commerce'],
    goals: ['streamline-operations', 'increase-sales'],
    industries: ['technology', 'finance', 'retail'],
    website: 'https://looker.com',
    imageUrl: 'https://logo.clearbit.com/looker.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['advanced'],
    minTeamSize: 'medium'
  }
];